export default __webpack_public_path__ + "static/media/logo_uni_horizontal_verde.2842bfb7.svg";